<template>
  <div>
    <slot />
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faShareAlt,
  faSpa,
} from '@fortawesome/pro-light-svg-icons';

import LocalizesRoutes from '@/mixins/LocalizesRoutes';

library.add({
  faShareAlt,
  faSpa,
});

export default {
  name: 'VetsterPartner',

  mixins: [LocalizesRoutes],

  created() {
    this.$store.commit('setFixedFooterBooking', true);
    window.addEventListener('popstate', this.redirectToGuidedSearch);
  },

  beforeDestroy() {
    window.removeEventListener('popstate', this.redirectToGuidedSearch);
  },

  methods: {
    /**
     * Guided search calling window.history.pushState() with the partner profile
     * URL causes issues with web browser back/forward navigation without a frontend
     * Vue router implementation. When navigating away from the partner profile to
     * guided search in browser history, ensure PHP route('guided-search.index')
     * redirects to /gs VetsterSearch.vue.
     *
     * @see "@/brand-components/GuidedSearch/VetsterPartnerDetails"
     */
    redirectToGuidedSearch() {
      const { href } = document.location;

      if (href.startsWith(this.guidedSearchUrl)) {
        window.location.href = href;

        return false;
      }

      return true;
    },
  },
};
</script>
